import { COLOR_PALETTE_DEFAULT_COLOR } from '@/constant';

angular.module('inspinia').directive('baseColorPalette', () => {
  return {
    restrict: 'E',
    scope: {
      onClick: '&',
      ngModel: '=',
      colors: '@',
    },
    templateUrl: `/manage/src/view/directive/base_color_palette.html?${new Date().getTime()}`,
    link: ($scope) => {
      $scope.switchDisplayPalette = 'hidePalette';

      /**
       * 最初に表示するカラーを取得
       */
      const initializeColor = () => {
        $scope.ngModel = $scope.ngModel || COLOR_PALETTE_DEFAULT_COLOR.NAME;
        $scope.displayColor = $scope.ngModel;
      };
      initializeColor();

      /**
       * カラーパレットで選択出来る色の一覧を取得
       */
      $scope.getColorTypes = () => {
        const parsedColors = JSON.parse($scope.colors);
        if (!parsedColors.length) throw new Error('colors not found.');
        return parsedColors;
      };

      /**
       * カラーパレットの開閉
       */
      $scope.toggleColorPalette = () => {
        $scope.switchDisplayPalette = $scope.switchDisplayPalette === 'showPalette' ? 'hidePalette' : 'showPalette';
      };

      /**
       * カラーパレットの色の選択
       */
      $scope.onClickColorPalette = (selectedColorName) => {
        $scope.displayColor = selectedColorName;
        $scope.ngModel = selectedColorName;

        const setValue = () => $scope.onClick();
        setTimeout(setValue, 100);
      };
    },
  };
});
